import { render, staticRenderFns } from "./PowerpackDimension.vue?vue&type=template&id=08dc12b4&scoped=true"
import script from "./PowerpackDimension.vue?vue&type=script&lang=js"
export * from "./PowerpackDimension.vue?vue&type=script&lang=js"
import style0 from "./PowerpackDimension.vue?vue&type=style&index=0&id=08dc12b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dc12b4",
  null
  
)

export default component.exports